import React, { useContext } from 'react';

import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { useHistory } from 'react-router-dom';
import { wwwDir } from '../../utils/cordovaGlobals';
import airGreenLandAppButton from '../../assets/img/airGreenlandAppButton.png';
import Text from '../UI/Text/Text';
import { NavigationContext } from '../../context/navigation';

const BoardingPassWallet = () => {
  const { appEmbedded } = useContext(NavigationContext);
  const history = useHistory();

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const goToAirGreenlandApp = () => {
    if (appEmbedded) {
      history.push('/?didCompleteCheckin=true');
    } else {
      openInNewTab('https://www.airgreenland.dk/club-timmisa');
    }
  };

  return (
    <Box my={5}>
      <Typography variant="h2"><Text id="boarding-pass-title-airgreenland" /></Typography>
      <Typography><Text id="boarding-pass-airgreenland-banner" /></Typography>
      <ButtonBase
        fullWidth
        color="secondary"
        variant="contained"
        onClick={(() => goToAirGreenlandApp())}
      >
        <img src={`${wwwDir}${airGreenLandAppButton}`} alt="Air greenland app Button" />
      </ButtonBase>
    </Box>
  );
};

BoardingPassWallet.propTypes = {};

export default BoardingPassWallet;
